<template>
  <div class="con-wrap" 
      v-loading="loading"
      element-loading-text="拼命加载中">
    <p class="box-title">违章查询</p>
    <div class="data-wrap">
      <div class="queryBox">
        <el-button type="primary" v-if="hasPerm('vehicle:violation:query')" @click="query" style="margin-right:20px">查询</el-button>
        <span class="queryDesc">说明：系统默认每月1号零点自动查询一次违章记录</span>
      </div>
      <div class="illegally-wrap">
        <p class="queryTime" v-if="queryTime">最新查询时间：{{queryTime}}</p>
        <div v-if="illegallyData&&illegallyData.length>0">
          <ul class="illegallyUndeal">
            <li class="illegally-box" :key="index" v-for="(item,index) of illegallyData">
              <p class="illegally-time">{{item.time}}</p>
              <div class="illegally-content">
                  <div class="illegally-title">扣分</div>
                  <div class="illegally-desc">{{item.degree}}</div>
              </div>
              <div class="illegally-content">
                  <div class="illegally-title">违章地址</div>
                  <div class="illegally-desc">{{item.address}}</div>
              </div>
              <div class="illegally-content">
                  <div class="illegally-title">罚款原因</div>
                  <div class="illegally-desc">{{item.reason}} </div>
              </div>
              <div class="illegally-content">
                  <div class="illegally-title">违章处理部门</div>
                  <div class="illegally-desc">{{item.department}}</div>
              </div>
              <div class="illegally-content">
                  <div class="illegally-title">违章所在城市</div>
                  <div class="illegally-desc">{{item.cityName}}</div>
              </div>
              <div class="illegally-content">
                  <div class="illegally-title">罚款金额</div>
                  <div class="illegally-desc">{{item.money}}</div>
              </div>
            </li>
          </ul>
        </div>
        <div v-else class="no-illegally-wrap">{{wranMess}}</div>
        <div v-if="illegallyedData&&illegallyedData.length>0">
          <p class="illegallyDealed">已处理违章查询</p>
          <ul class="illegallyUndeal illegallydeal">
            <li class="illegally-box" :key="index" v-for="(item,index) of illegallyedData">
              <p class="illegally-time">{{item.time}}</p>
              <div class="illegally-content">
                  <div class="illegally-title">扣分</div>
                  <div class="illegally-desc">{{item.degree}}</div>
              </div>
              <div class="illegally-content">
                  <div class="illegally-title">违章地址</div>
                  <div class="illegally-desc">{{item.address}}</div>
              </div>
              <div class="illegally-content">
                  <div class="illegally-title">罚款原因</div>
                  <div class="illegally-desc">{{item.reason}} </div>
              </div>
              <div class="illegally-content">
                  <div class="illegally-title">违章处理部门</div>
                  <div class="illegally-desc">{{item.department}}</div>
              </div>
              <div class="illegally-content">
                  <div class="illegally-title">违章所在城市</div>
                  <div class="illegally-desc">{{item.cityName}}</div>
              </div>
              <div class="illegally-content">
                  <div class="illegally-title">罚款金额</div>
                  <div class="illegally-desc">{{item.money}}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>      
    </div>
  </div>
</template>

<script>
export default {
  name: "IllegallyInquiry",
  props: {
    vin: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading:false,
      illegallyData: [],
      illegallyedData:[],
      queryTime:null,
      wranMess: '',
    }
  },
  mounted(){
    this.getIllegallyData('1')
    this.getIllegallyedData()
  },
  methods: {
    getCurrentTime() {
        const yy = new Date().getFullYear()
        const mm = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1
        const dd = new Date().getDate() < 10 ? '0' + new Date().getDate()
          : new Date().getDate()
        const hh = new Date().getHours()
        const mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
        const ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds()
          : new Date().getSeconds()
        this.queryTime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
    },
    query() {
      this.getIllegallyData('0')
      this.getIllegallyedData()
    },
    async getIllegallyData(handle) {
      let _this = this
      let obj = {
        vin: _this.vin,
        handle:handle
      }
      _this.loading=true
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/violation/list",
        {
          params: obj,
        }
      )
      if (res.code == 1) {
        _this.loading=false
        _this.queryTime=res.data.flushTime
        _this.illegallyData = res.data.list
        if(_this.illegallyData.length==0){
          _this.wranMess='暂无未处理违章信息'
        }
      } else if(res.code == 7) {
        _this.queryTime=res.data.flushTime
        _this.wranMess = res.msg
        _this.loading=false
      }else{
        _this.wranMess = res.msg
        _this.loading=false
        _this.$message.warning(res.msg)
      }
    },
    // 查询已处理违章
    async getIllegallyedData() {
      let _this = this
      let obj = {
        vin: _this.vin
      }
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/violation/list/handle",
        {
          params: obj,
        }
      )
      if (res.code == 1) {
        _this.illegallyedData = res.data
      }else{
        _this.$message.warning(res.msg)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.con-wrap {
  height: 100%;
  margin: 0;
  background-color: #fff;
}
.con-wrap .box-title {
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  background: #f8f8f8;
}
.data-wrap {
  width: 100%;
  height: calc(100% - 31px);
  padding: 20px 0px;
  box-sizing: border-box;
}
.queryBox{
  position: relative;
  padding:0px 20px;
}
.queryDesc{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  position: absolute;
  bottom:-5px;
}
.queryTime{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 35px;
  padding:0px 20px;
}
.no-illegally-wrap{
    color:#f00;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    padding-left:20px;
}
.illegally-wrap{
    width:100%;
    margin-top:20px;
    border-top: 1px solid #F4F4F4;
    .illegallyUndeal{
      padding:0px 20px;
      .illegally-box{
        width: 360px;
        background: #FAFAFA;
        margin-right: 20px;
        margin-bottom: 20px;
        float:left;
        .illegally-time{
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          line-height: 32px;
          background: #F4F4F4;
          text-indent: 20px;
        }
        .illegally-content{
          padding:5px 10px;
          width: 340px;
          .illegally-title{
            width:90px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #000000;
            text-align: right;
            float: left;
            margin-right: 10px;
          }
          .illegally-desc{
            width: 210px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }
    }
    .illegallydeal{
      .illegally-time{
        color:#999999!important;
      }
      .illegally-title{
        color:#999999!important;
      }
      .illegally-desc{
        color:#999999!important;
      }
    }
    .illegallyDealed{
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      width:100%;
      height:35px;
      line-height: 35px;
      background: #F8F8F8;
      margin:20px 0px;
    }
}


.illegally-content:after{
  content: " "; 
  display: block; 
  height: 0; 
  clear: both; 
  visibility: hidden;  
}
.illegallyUndeal:after{
  content: " "; 
  display: block; 
  height: 0; 
  clear: both; 
  visibility: hidden;  
}
.illegally-content {
  /* 触发 hasLayout */ 
  zoom: 1; 
}
</style>